import { Box, Flex, Grid, GridItem, IconButton, Spinner } from '@chakra-ui/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { MdNavigateBefore, MdNavigateNext, MdOutlineFirstPage, MdOutlineLastPage } from 'react-icons/md';

import { EquipmentModel } from '@app/api/models/equipment';
import { useFetchData, useApi } from '@app/hooks';

import { Paper } from '../common/paper';
import ModelCard from './model-card';
import { Txt } from '../common/text';

const PAGE_SIZE = 10;

export const EquipmentsGuideMobileView = () => {
  const [models, setModels] = useState<EquipmentModel[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  
  const api = useApi();
  const [fetchData] = useFetchData<EquipmentModel>({ method: api.equipments.getEquipmentsGuides });

  const fetch = useCallback( async () => { 
    setLoading(true);
    const { total, data } = await fetchData({
      pagination: { page, pageSize: PAGE_SIZE },
      sort: { name: 'on_balance', direction: 'desc' },
      filter: [],
      filterRaw: {}
    });
    setTotal(total);
    setModels(data);
    setLoading(false);
  }, [page]);

  useEffect(() => {
    void fetch();
  }, [page]);

  const lastPage = useMemo(
    () => Math.ceil(total / PAGE_SIZE),
    [total]
  );

  const onPrevPageClick = () => {
    setModels([]);
    page !== 1 && setPage(page - 1);
  };

  const onNextPageClick = () => {
    setModels([]);
    page !== lastPage && setPage(page + 1);
  };
  
  return (
    <>
      <Grid templateColumns='1fr'>
        {loading && <Flex justifyContent='center' minH="100vh" alignItems='center'><Spinner /></Flex>}
        {models.map((item) => (
          <GridItem key={item.id}>
            <ModelCard item={item} />
          </GridItem>
        ))}

        <GridItem>
          <Paper>
            <Box display='flex' alignItems='center' gap={2} px={5} py={3} justifyContent='center' >
              <IconButton size='sm' icon={<MdOutlineFirstPage size='24px' />} aria-label="first-page" onClick={() => setPage(1)}     />
              <IconButton size='sm' 
                icon={<MdNavigateBefore size='24px' />} aria-label="prev-page" 
                opacity={page === 1 ? 0.5 : 1} onClick={onPrevPageClick} 
              />
              <Txt mx={2}>{page}</Txt>
              <IconButton size='sm' 
                icon={<MdNavigateNext size='24px' />} aria-label="next-page"
                opacity={page === lastPage ? 0.5 : 1} onClick={onNextPageClick} 
              />
              <IconButton size='sm' icon={<MdOutlineLastPage size='24px' />} aria-label="last-page" onClick={() => setPage(lastPage)}/>
            </Box>
          </Paper>
        </GridItem>
      </Grid>
    </>
  );
};